module.exports = __webpack_public_path__ + "static/img/11.8cb60f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/eng/11.png
// module id = HFMy
// module chunks = 0